export default __webpack_public_path__ + "static/media/essay-rich-text-blue.c6b5bfab.svg";